export default "__VITE_ASSET__B4LXNt1x__"